document.addEventListener('DOMContentLoaded',()=>{
  const header=document.querySelector('.nivo-header');
  const toggle=document.querySelector('[data-menu-toggle]');
  const menu=document.querySelector('[data-mobile-menu]');

  const closeMenu=()=>{
    menu?.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded','false');
    document.body.classList.remove('nivo-menu-open');
  };

  toggle?.addEventListener('click',()=>{
    const open=!menu.classList.contains('is-open');
    menu.classList.toggle('is-open',open);
    toggle.setAttribute('aria-expanded',open);
    document.body.classList.toggle('nivo-menu-open',open);
  });

  menu?.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));

  const onScroll=()=>header?.classList.toggle('is-scrolled',window.scrollY>30);
  onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});

  const searchModal=document.querySelector('[data-search-modal]');
  const searchInput=searchModal?.querySelector('input[type=search]');
  const searchToggles=document.querySelectorAll('[data-search-toggle]');
  const searchCloseEls=searchModal?.querySelectorAll('[data-search-close]') || [];
  let searchReturnFocus=null;
  const closeSearch=()=>{
    if(!searchModal)return;
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden','true');
    searchToggles.forEach(el=>el.setAttribute('aria-expanded','false'));
    document.body.classList.remove('nivo-search-open');
    searchReturnFocus?.focus?.();
  };
  const openSearch=()=>{
    if(!searchModal)return;
    searchReturnFocus=document.activeElement;
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden','false');
    searchToggles.forEach(el=>el.setAttribute('aria-expanded','true'));
    document.body.classList.add('nivo-search-open');
    requestAnimationFrame(()=>searchInput?.focus());
  };
  searchToggles.forEach(el=>el.addEventListener('click',openSearch));
  searchCloseEls.forEach(el=>el.addEventListener('click',closeSearch));
  searchInput?.addEventListener('keydown',e=>{if(e.key==='Escape')closeSearch()});
  document.addEventListener('keydown',e=>{if(e.key==='Escape' && searchModal?.classList.contains('is-open'))closeSearch()});

  const observer=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add('is-visible');
        observer.unobserve(e.target);
      }
    });
  },{threshold:.12});
  document.querySelectorAll('.reveal').forEach(el=>observer.observe(el));

  const community=document.querySelector('#community');
  if(community){
    const track=community.querySelector('[data-community-track]');
    const cards=[...community.querySelectorAll('.social-card')];
    const counter=community.querySelector('[data-community-counter]');
    let index=0;
    const visible=()=>window.innerWidth<=560?2:4;
    const render=()=>{
      const shown=visible();
      const max=Math.max(0,cards.length-shown);
      index=Math.min(index,max);
      const pct=100/shown;
      track.style.transform=`translateX(-${index*pct}%)`;
      if(counter) counter.textContent=`${String(index+1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`;
    };
    community.querySelector('[data-community-next]')?.addEventListener('click',()=>{
      index++;
      if(index>cards.length-visible()) index=0;
      render();
    });
    community.querySelector('[data-community-prev]')?.addEventListener('click',()=>{
      index--;
      if(index<0) index=Math.max(0,cards.length-visible());
      render();
    });
    window.addEventListener('resize',render,{passive:true});
    render();
  }

  const modal=document.querySelector('[data-password-modal]');
  if(modal){
    const open=()=>{
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      modal.querySelector('input')?.focus();
    };
    const close=()=>{
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
    };
    document.querySelectorAll('[data-password-toggle]').forEach(el=>el.addEventListener('click',open));
    document.querySelector('[data-password-close]')?.addEventListener('click',close);
    modal.addEventListener('click',e=>{if(e.target===modal)close()});
    document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
  }
});

/* nivo. cart drawer — native Shopify Cart API + bundled section rendering */
document.addEventListener('DOMContentLoaded',()=>{
  const root=document.body;
  const drawer=()=>document.querySelector('[data-cart-drawer]');
  const addUrl=root.dataset.cartAddUrl;
  const localeRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  const updateBadge=(count)=>document.querySelectorAll('.bag-count').forEach(el=>{el.textContent=count>0?count:'';el.classList.toggle('is-visible',count>0)});
  const setBusy=(button,busy)=>{if(button){button.disabled=busy;button.setAttribute('aria-busy',busy?'true':'false')}};
  const open=()=>{const d=drawer();if(!d)return;d.classList.add('is-open');d.setAttribute('aria-hidden','false');document.body.classList.add('nivo-cart-open');document.body.style.overflow='hidden'};
  const close=()=>{const d=drawer();if(!d)return;d.classList.remove('is-open');d.setAttribute('aria-hidden','true');document.body.classList.remove('nivo-cart-open');document.body.style.overflow=''};
  const replaceDrawer=(html)=>{
    if(!html)return;
    const doc=new DOMParser().parseFromString(html,'text/html');
    const next=doc.querySelector('[data-cart-drawer]');
    const current=drawer();
    if(next&&current){const wasOpen=current.classList.contains('is-open');current.replaceWith(next);if(wasOpen)open();}
  };
  const renderFromResponse=async(response)=>{
    const data=await response.json();
    if(!response.ok)throw new Error(data.description||'Cart error');
    updateBadge(data.item_count||0);
    if(data.sections&&data.sections['nivo-cart-drawer'])replaceDrawer(data.sections['nivo-cart-drawer']);
    return data;
  };
  const setLine=async(key,quantity,button)=>{
    setBusy(button,true);
    try{
      const body=new URLSearchParams({id:key,quantity:String(Math.max(0,quantity)),sections:'nivo-cart-drawer',sections_url:window.location.pathname+window.location.search});
      const response=await fetch(localeRoot+'cart/change.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},body});
      await renderFromResponse(response);
    }catch(e){console.error(e)}finally{setBusy(button,false)}
  };
  const changeLine=async(button,delta)=>{
    const item=button.closest('[data-cart-line]');
    if(!item)return;
    const qtyEl=item.querySelector('[data-cart-quantity]');
    const quantity=parseInt(qtyEl?.textContent||'1',10)||1;
    await setLine(button.dataset.line,quantity+delta,button);
  };
  document.addEventListener('click',e=>{
    const toggle=e.target.closest('[data-cart-toggle]');
    if(toggle&&window.matchMedia('(min-width:561px)').matches){e.preventDefault();open();return}
    if(e.target.closest('[data-cart-close]')){e.preventDefault();close();return}
    const inc=e.target.closest('[data-cart-increase]');
    if(inc){e.preventDefault();changeLine(inc,1);return}
    const dec=e.target.closest('[data-cart-decrease]');
    if(dec){e.preventDefault();changeLine(dec,-1);return}
    const rem=e.target.closest('[data-cart-remove]');
    if(rem){e.preventDefault();setLine(rem.dataset.line,0,rem);return}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawer()?.classList.contains('is-open'))close()});
  document.querySelectorAll('[data-product-form]').forEach(form=>form.addEventListener('submit',async e=>{
    e.preventDefault();
    const data=new FormData(form);data.append('sections','nivo-cart-drawer');data.append('sections_url',window.location.pathname+window.location.search);
    try{const response=await fetch(addUrl+'.js',{method:'POST',headers:{Accept:'application/json'},body:data});await renderFromResponse(response);open();}
    catch(err){console.error(err);form.submit()}
  }));
});

/* nivo. predictive search — Shopify Predictive Search API */
document.addEventListener('DOMContentLoaded',()=>{
  const modal=document.querySelector('[data-search-modal]');
  const input=modal?.querySelector('input[name="q"]');
  const box=modal?.querySelector('[data-predictive-search]');
  if(!input||!box)return;
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  let timer;
  let controller;
  const clear=()=>{box.innerHTML='';box.classList.remove('is-visible');box.setAttribute('aria-busy','false')};
  const search=async q=>{
    const term=q.trim();
    if(term.length<2){clear();return}
    controller?.abort();controller=new AbortController();box.setAttribute('aria-busy','true');
    try{
      const url=new URL(root+'search/suggest.json',window.location.origin);
      url.searchParams.set('q',term);url.searchParams.set('resources[type]','product,collection,page,article');url.searchParams.set('resources[limit]', '4');
      const response=await fetch(url,{headers:{Accept:'application/json'},signal:controller.signal});
      const data=await response.json();
      const resources=data.resources?.results||{};
      const products=resources.products||[];
      const collections=resources.collections||[];
      const pages=resources.pages||[];
      const articles=resources.articles||[];
      if(!products.length&&!collections.length&&!pages.length&&!articles.length){clear();box.innerHTML='<div class="nivo-search-predictive-empty">'+(input.dataset.noResults||'')+'</div>';box.classList.add('is-visible');return}
      let html='<div class="nivo-search-predictive-grid">';
      products.forEach(p=>{html+='<a class="nivo-search-predictive-item" href="'+p.url+'">'+(p.image?'<img src="'+p.image+'" alt="">':'<span></span>')+'<span><strong>'+p.title+'</strong><span>'+((p.price||'') )+'</span></span></a>'});
      [...collections,...pages,...articles].slice(0,4).forEach(r=>{html+='<a class="nivo-search-predictive-item" href="'+r.url+'"><span></span><span><strong>'+r.title+'</strong><span>'+r.type+'</span></span></a>'});
      html+='</div>';box.innerHTML=html;box.classList.add('is-visible');box.setAttribute('aria-busy','false');
    }catch(err){if(err.name!=='AbortError')clear()}
  };
  input.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(()=>search(input.value),180)});
  modal?.addEventListener('click',e=>{if(e.target.closest('[data-search-close]'))clear()});
});
